import { TypesenseAuctionDetails } from '@bonhams1793/bonhams-typescript'

import { TypesenseClientInstance } from '../typesenseClient'

export type GetTypesenseAuctionDetailsProps = {
  id: string | number
}

export function getTypesenseAuctionDetails({
  getTypesenseClient,
}: TypesenseClientInstance) {
  return async ({ id }: GetTypesenseAuctionDetailsProps) => {
    try {
      return await getTypesenseClient()
        .collections<TypesenseAuctionDetails>('auction-details')
        .documents(id.toString())
        .retrieve()
    } catch {
      return null
    }
  }
}
